import React, { useEffect, useContext, useRef} from 'react'
import { VenueContext } from "./Context"
import {TweenMax, Power3} from "gsap"
import LandingPage1 from "./LandingPage1.jpeg"

function LandingPage() {
    const { getSpecificVenues} = useContext(VenueContext);
    let landingText = useRef(null);
    let hText = useRef(null);
    let pText = useRef(null);
    let button = useRef(null);

        useEffect(() => {
            window.scrollTo(0, 0);
            TweenMax.to(landingText, 0, { css: { visibility: "visible"}})
           TweenMax.staggerFrom([hText, pText, button], .8, {opacity: 0, x: -500, ease: Power3.easeOut}, .2)
        }, [])

   
    return (
            <div id="Landing-hero" style={{ background: `url(${LandingPage1 }) center`, backgroundSize: "cover" }}>
                <div className="container-fluid">
                <div ref={element => landingText = element} className="landing-text col-lg-6">
                    <div className="header-heading" ref={element => hText = element}>
                            Discover the perfect venue for your event
                     </div>
                    <p className="heading-sub" ref={element => pText = element}>
                            Book directly from local hosts, less hassle more fun
                    </p>
                        <a href="#Explore">
                        <button ref={element => button = element} className="text-center venue-button" onClick={() => {getSpecificVenues(324) }}>
                            <i className="fas fa-map-marker-alt"></i> <span className="venue-find"> Find Venues </span>
                        </button>
                        </a>
                    </div>
                </div>
            </div>
    )
}
export default LandingPage
